import resolve from 'ioc/resolve'

export const KEY = 'LastProductList';

export function resolveRetailerId(retailerId) {
    return retailerId || resolve("$cart").retailerId || resolve("$session").retailerId  || '*';
};

export function resolveCache() {
    return resolve('$localStorage')[KEY] || (resolve('$localStorage')[KEY] = {});
};

export function record(listId, _retailerId) {
    const cache = resolveCache();
    const retailerId = resolveRetailerId(_retailerId);
    cache[retailerId] = listId;
    //console.log(KEY, listId, retailerId, cache);
    return cache;
};

export function get(_retailerId) {
    const cache = resolveCache();
    const retailerId = resolveRetailerId(_retailerId);
    //console.log(KEY, retailerId, cache);
    return cache[retailerId];
};

export default {
    record,
    get,
    resolveRetailerId,
    resolveCache,
};